<template>
    <div class="qksm qksm6">
        <h4>六、关于{{$store.state.divData.divname}}2022年一般公共预算基本支出情况说明</h4>
        <div class="nogap">
            <p>{{$store.state.divData.divname}}2022年一般公共预算基本支出{{isMoney(T6.合计)}}万元，其中：</p>
            <p>
                人员经费{{isMoney(T6.人员经费)}}万元，主要包括：
                <span v-if="num(T6.人员经费)==0">无；</span>
                <span v-for="(item, idx) in T6.人员经费包括" :key="idx" v-else>
                    {{item.name}}{{isMoney(item.value)}}万元{{idx==T6.人员经费包括.length-1?'；':'、'}}
                </span>
            </p>
            <p>
                公用经费{{isMoney(T6.公用经费)}}万元，主要包括：
                <span v-if="num(T6.公用经费)==0">无。</span>
                <span v-for="(item, idx) in T6.公用经费包括" :key="idx" v-else>
                    {{item.name}}{{isMoney(item.value)}}万元{{idx==T6.公用经费包括.length-1?'。':'、'}}
                </span>
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm6",
        props: {
            T6: {
                type: Object,
                default: "",
            },
        },
    };
</script>